// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__13LZU","overflowing":"ReadFullNote_overflowing__2OYHu"};